// Scrub tokens / PII from strings and URLs before sending to admin log.

const SENSITIVE_KEYS =
  /^(pass(word)?|token|access[_-]?token|refresh[_-]?token|api[_-]?key|secret|authorization|cookie|card(number)?|cvv|cvc|pan|iban|ssn|otp|pin)$/i;

const SENSITIVE_QUERY = [
  "token",
  "access_token",
  "refresh_token",
  "code",
  "id_token",
  "api_key",
  "apikey",
  "session",
  "password",
  "email",
  "phone",
  "otp",
  "pin",
  "iban",
];

// Real email regex — matches the whole string, not "contains @".
const EMAIL_RE = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

export function scrubUrl(input: string | null | undefined): string {
  if (!input) return "";
  try {
    const u = new URL(input, typeof window !== "undefined" ? window.location.origin : "http://x/");
    for (const k of Array.from(u.searchParams.keys())) {
      if (SENSITIVE_QUERY.includes(k.toLowerCase())) u.searchParams.set(k, "***");
    }
    return u.pathname + (u.search || "") + (u.hash || "");
  } catch {
    return String(input).slice(0, 500);
  }
}

export function maskEmail(e: unknown): string {
  if (typeof e !== "string" || !EMAIL_RE.test(e)) return String(e ?? "");
  const [u, d] = e.split("@");
  const head = u.length <= 2 ? u : u.slice(0, 2);
  return `${head}${"*".repeat(Math.max(1, u.length - 2))}@${d}`;
}

// deep clone with scrubbing; caps depth & string length
export function scrubValue(v: unknown, depth = 0): unknown {
  if (depth > 4) return "[deep]";
  if (v == null) return v;
  if (typeof v === "string") {
    if (v.length > 2000) return v.slice(0, 2000) + "…";
    // only mask if the entire string looks like an email
    if (EMAIL_RE.test(v)) return maskEmail(v);
    return v;
  }
  if (typeof v === "number" || typeof v === "boolean") return v;
  if (Array.isArray(v)) return v.slice(0, 50).map((x) => scrubValue(x, depth + 1));
  if (typeof v === "object") {
    const out: Record<string, unknown> = {};
    let i = 0;
    for (const [k, val] of Object.entries(v as Record<string, unknown>)) {
      if (i++ > 50) break;
      if (SENSITIVE_KEYS.test(k)) {
        out[k] = "***";
      } else {
        out[k] = scrubValue(val, depth + 1);
      }
    }
    return out;
  }
  return String(v).slice(0, 500);
}
